import "./index.scss";
import "react-smartbanner/dist/main.css";

import * as Sentry from "@sentry/react";
import i18n from "i18next";
import React from "react";
import ReactDOM from "react-dom/client";
import { initReactI18next } from "react-i18next";
import SmartBanner from "react-smartbanner";

import { ampli } from "./ampli";
import { App } from "./App";
import { registerServiceWorker } from "./firebase/firebase";

import { development, production } from "./setup/constants";

import * as ar from "./translations/ar.json";
import { AuthConfig } from "./setup/context/config/authConfig";
import ErrorBoundary from "./components/common/errorBoundary";
import SomethingWentWrong from "./components/common/SomethingWentWrong";

// styles
import "./index.scss";

// Save the original method
const originalRemoveChild = Node.prototype.removeChild;

// Polyfill for removeChild
if (typeof Node === "function" && Node.prototype) {
  Node.prototype.removeChild = function <T extends Node>(child: T): T {
    // Ensure the child is part of this node before removing it
    if ((child as unknown as ChildNode).parentNode !== this) {
      console.error(
        "Failed to remove child: The node to be removed is not a child of this node.",
        child,
        this
      );
      return child; // Return the child for consistent behavior
    }
    // Use call to maintain the correct context and type
    return originalRemoveChild.call(
      this,
      child as unknown as ChildNode
    ) as unknown as T;
  };
}

// Save the original method
const originalAppendChild = Node.prototype.appendChild;

// Polyfill for appendChild
if (typeof Node === "function" && Node.prototype) {
  Node.prototype.appendChild = function <T extends Node>(this: T, child: T): T {
    // Check if this (parent node) is not null and is an instance of Node
    if (this === null || !(this instanceof Node)) {
      console.error(
        "Failed to append child: The parent node is not valid.",
        this,
        child
      );
      return child;
    }
    // Call the original method
    return originalAppendChild.call(this, child) as T;
  };
}

// Use this function if you need to revert back to the original behavior at any point

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN_LINK,
  enabled: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  ignoreErrors: [
    "Remote Config: Fetch client failed to connect to a network",
    "Load failed. (remoteconfig/fetch-client-network)",
  ],
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const urlParams = new URLSearchParams(window?.location?.search);
const deviceId = urlParams?.get("deviceId");

const isWebView = AuthConfig.getUserInfo()?.webView;

ampli.load({
  environment: process.env.NODE_ENV === development ? development : production,
  ...(deviceId ? { deviceId: deviceId } : {}),
});

i18n.use(initReactI18next).init({
  resources: {
    ar: {
      translation: ar,
    },
  },
});
i18n.changeLanguage("ar");

root.render(
  <div>
    {!isWebView && (
      <SmartBanner
        title={"Waffy وفّي"}
        author={"حمل التطبيق الآن واحفظ حقوقك"}
        button={"حمل الآن"}
      />
    )}
    <ErrorBoundary fallback={<SomethingWentWrong />}>
      <App />
    </ErrorBoundary>
  </div>
);

registerServiceWorker();
